import { render, staticRenderFns } from "./ProductBundleEdit.vue?vue&type=template&id=3ed35709&scoped=true&"
import script from "./ProductBundleEdit.vue?vue&type=script&lang=js&"
export * from "./ProductBundleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed35709",
  null
  
)

export default component.exports